import React from "react";
import { Col, Container, Row } from "react-bootstrap";

function Fiveuniquestyle() {
  return (
    <section className="video_production p-100">
      <Container>
        <Row>
          <Col
            xs={12}
            md={7}
            lg={6}
            xl={7}
            xxl={6}
            className="m-auto text-center"
          >
            <h2>
              SaaS Video Production <span>5 Unique Styles</span>
            </h2>
            <p>
              There’s no better way to creating stellar software explainer
              videos than simply experimenting with fascinating, and
              high-quality animation. Here are five unique styles we use for
              creating your SaaS story:
            </p>
          </Col>
        </Row>
        <Row>
          <Col xs={12} md={12} lg={12} xl={12} xxl={12}>
            <div className="video_valuee_main">
              <div className="value_item_video">
                <p>Cutout</p>
              </div>
              <div className="value_item_video">
                <p>Motion Graphics</p>
              </div>
              <div className="value_item_video">
                <p>Whiteboard</p>
              </div>
              <div className="value_item_video">
                <p>Frame by Frame</p>
              </div>
              <div className="value_item_video">
                <p>Live shooting</p>
              </div>
            </div>
          </Col>
        </Row>
      </Container>
    </section>
  );
}

export default Fiveuniquestyle;
